export const getOrangeActionButtonSx = (theme) => ({
	backgroundColor: `${theme.palette.orange.main} !important`,
	color: `${theme.palette.orange.contrastText} !important`,
	border: `1px solid ${theme.palette.orange.border}`,
	fontSize: theme.spacing(1.75),
	fontWeight: 400,
	textTransform: 'none',
	py: 0.5,
	minHeight: theme.spacing(4),
	'&.MuiButton-contained': {
		backgroundColor: `${theme.palette.orange.main} !important`,
		color: `${theme.palette.orange.contrastText} !important`,
		border: `1px solid ${theme.palette.orange.border} !important`,
	},
	'&:hover': {
		backgroundColor: `${theme.palette.orange.dark} !important`,
		borderColor: `${theme.palette.orange.dark} !important`,
	},
});
